import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createApp } from '../../store/actions/createApp'
const CreateApp = () => {
    const dispatch = useDispatch();
    const data = useSelector(state => state.createapp && state.createapp.createAppData)
    const generate = () => {
        dispatch(createApp());
    }
    return (
        <>
            <button className="searchbt" onClick={generate}>
                Generate App
            </button>
            <div>
                <pre>{data && JSON.stringify(data, null, 2)}</pre>
            </div>
        </>
    )
}

export default CreateApp;


